import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';

import DialogViewWrapper from 'components/DialogViewWrapper';
import Loader from 'components/Loader';
import { actionTemplatesApi } from 'config/api/actionLibrary/actionLibrary';
import type { ActionTemplate } from 'config/api/actionLibrary/actionLibrary.types';
import action_library_messages from 'messages/action_library_messages';
import PATHS from 'router/PATHS';

import ActionTemplateActions from './_components/ActionTemplateActions/ActionTemplateActions';
import ActionTemplateDetails from './_components/ActionTemplateDetails/ActionTemplateDetails';

const ActionLibraryDetailPage: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  const [template, setTemplate] = useState<ActionTemplate | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const loadTemplate = async () => {
      try {
        setLoading(true);
        const { data } = await actionTemplatesApi.getSingleActionTemplate(Number(id));
        setTemplate(data);
        setError(null);
      } catch (err) {
        setError(err as Error);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      loadTemplate();
    }
  }, [id]);

  const handleDelete = () => {
    history.push(PATHS.ACTION_LIBRARY);
  };

  const handleCopy = (newTemplate: ActionTemplate) => {
    history.push(PATHS.ACTION_LIBRARY_DETAIL.replace(':id', newTemplate.id.toString()));
  };

  const handleBack = () => {
    history.push(PATHS.ACTION_LIBRARY);
  };

  if (loading) {
    return (
      <DialogViewWrapper contentSize='lg' onBack={handleBack} title={t(action_library_messages.detail.page_title)}>
        <Loader inner />
      </DialogViewWrapper>
    );
  }

  if (error || !template) {
    return (
      <DialogViewWrapper contentSize='lg' onBack={handleBack} title={t(action_library_messages.detail.page_title)}>
        <div>{t(action_library_messages.error_state.title)}</div>
      </DialogViewWrapper>
    );
  }

  return (
    <DialogViewWrapper contentSize='lg' onBack={handleBack} title={t(action_library_messages.detail.page_title)}>
      <ActionTemplateDetails template={template} />
      <ActionTemplateActions onCopy={handleCopy} onDelete={handleDelete} template={template} />
    </DialogViewWrapper>
  );
};

export default ActionLibraryDetailPage;
